import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Input, Select } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import { loginUserCheck, logoutUser, productCreate } from "../redux/actions";

class AdminAddProduct extends Component {
  constructor() {
    super();
    this.state = {
      product_code: "",
      brand_title: "",
      brand_id: "",
      photo: "",
      type: "wall",
      title: "",
      price: "",
      price2: "",
      price3: "",
      price4: "",
      price5: "",
      inventory: "",
      btu: "",
      com: "",
      spare: "",
      size: "",
      air_type: "",
      efficiency: "",
      coil: "",
      swing: "",
      purify: "",
      liquid: "",
      catalog: "",
      description: "",
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    const params = this.getParams();
    this.setState({
      brand_id: params.id,
      brand_title: params.title,
      type: params.type,
    });
  }

  getParams() {
    const searchParams = new URLSearchParams(this.props.location.search);
    return {
      id: searchParams.get("id") || "",
      title: searchParams.get("title") || "",
      type: searchParams.get("type") || "wall",
    };
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _onSubmit() {
    let {
      product_code,
      brand_title,
      brand_id,
      photo,
      type,
      title,
      price,
      price2,
      price3,
      price4,
      price5,
      inventory,
      btu,
      com,
      spare,
      size,
      air_type,
      efficiency,
      coil,
      swing,
      purify,
      liquid,
      catalog,
      description,
    } = this.state;
    const data = {
      prod_id: new Date().getTime(),
      product_code,
      brand_title,
      brand_id,
      img: photo,
      type,
      title,
      price,
      price2,
      price3,
      price4,
      price5,
      inventory,
      btu,
      com,
      spare,
      size,
      air_type,
      efficiency,
      coil,
      swing,
      purify,
      liquid,
      catalog,
      order: 1,
      description,
      created_date: new Date().getTime(),
      updated_date: new Date().getTime(),
      created_by: this.props.user,
    };
    if (
      product_code &&
      brand_title &&
      brand_id &&
      photo &&
      type &&
      title &&
      price &&
      price2 &&
      price3 &&
      price4 &&
      price5
    ) {
      if (type === "wall") {
        this.props.productCreate(data, "type_wall");
      } else if (type === "hang") {
        this.props.productCreate(data, "type_hang");
      } else if (type === "four") {
        this.props.productCreate(data, "type_four");
      } else if (type === "concealed") {
        this.props.productCreate(data, "type_concealed");
      } else if (type === "stand") {
        this.props.productCreate(data, "type_stand");
      } else if (type === "one_way") {
        this.props.productCreate(data, "type_one_way");
      }
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-addproduct">
          <Nav active="product" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>
                  สินค้า :{" "}
                  <span className="brandname">{this.state.brand_title}</span>
                </h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <form className="form-container">
                    <div className="column">
                      <div className="photo">
                        <div className="brand-title">
                          <p>รูปสินค้า* :</p>
                        </div>
                        <div className="filename">
                          <p>{this.state.photo.name}</p>
                        </div>
                        <div className="photo-input">
                          <input
                            id="photo"
                            type="file"
                            name="photo"
                            accept="image/*"
                            hidden
                            onChange={(event) => this._onHandleChange(event)}
                          />
                          <label htmlFor="photo">เลือกรูปภาพ</label>
                        </div>
                      </div>
                      <div className="form-item">
                        <p>ประเภท* :</p>
                        <Select
                          name="type"
                          defaultValue={this.state.type}
                          onChange={(value) => this.setState({ type: value })}
                          style={{ width: "100%" }}
                          options={[
                            {
                              value: "wall",
                              label: "แอร์ผนัง",
                            },
                            {
                              value: "hang",
                              label: "แอร์แขวน",
                            },
                            {
                              value: "four",
                              label: "แอร์สี่ทิศทาง",
                            },
                            {
                              value: "concealed",
                              label: "แอรเ์ปลือย",
                            },
                            {
                              value: "stand",
                              label: "แอร์ตู้ตั้ง",
                            },
                            {
                              value: "one_way",
                              label: "แอร์หนึ่งทิศทาง",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>รุ่น* :</p>
                        <Input
                          type="text"
                          name="title"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>รหัสสินค้า* :</p>
                        <Input
                          name="product_code"
                          value={this.state.product_code}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 1)* :</p>
                        <Input
                          type="text"
                          name="price"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 2)* :</p>
                        <Input
                          type="text"
                          name="price2"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 3)* :</p>
                        <Input
                          type="text"
                          name="price3"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 4)* :</p>
                        <Input
                          type="text"
                          name="price4"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 5)* :</p>
                        <Input
                          type="text"
                          name="price5"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>จำนวนคงเหลือ :</p>
                        <Input
                          type="text"
                          name="inventory"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>BTU :</p>
                        <Input
                          type="text"
                          name="btu"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                    </div>
                    <div className="column">
                      <div className="form-item" style={{ marginTop: 0 }}>
                        <p>ประกันคอม (ปี) :</p>
                        <Input
                          type="text"
                          name="com"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ประกันอะไหล่ (ปี) :</p>
                        <Input
                          type="text"
                          name="spare"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ไซส์ท่อ :</p>
                        <Input
                          type="text"
                          name="size"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ระบบ :</p>
                        <Select
                          name="air_type"
                          onChange={(value) => this.setState({ air_type: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกระบบ"
                          options={[
                            {
                              value: "INVERTER",
                              label: "INVERTER",
                            },
                            {
                              value: "FIXSPEED",
                              label: "FIXSPEED",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>เบอร์ 5 :</p>
                        <Select
                          name="efficiency"
                          onChange={(value) => this.setState({ efficiency: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกเบอร์ 5"
                          options={[
                            {
                              value: "ไม่มีเบอร์ 5",
                              label: "ไม่มีเบอร์ 5",
                            },
                            {
                              value: "เบอร์ 5 : ไม่มีดาว",
                              label: "เบอร์ 5 : ไม่มีดาว",
                            },
                            {
                              value: "เบอร์ 5 : 1 ดาว",
                              label: "เบอร์ 5 : 1 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 2 ดาว",
                              label: "เบอร์ 5 : 2 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 3 ดาว",
                              label: "เบอร์ 5 : 3 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 4 ดาว",
                              label: "เบอร์ 5 : 4 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 5 ดาว",
                              label: "เบอร์ 5 : 5 ดาว",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>คอยล์ :</p>
                        <Select
                          name="coil"
                          onChange={(value) => this.setState({ coil: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกคอยล์"
                          options={[
                            {
                              value: "ทองแดง",
                              label: "ทองแดง",
                            },
                            {
                              value: "อลูมิเนียม",
                              label: "อลูมิเนียม",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>สวิง :</p>
                        <Select
                          name="swing"
                          onChange={(value) => this.setState({ swing: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกสวิง"
                          options={[
                            {
                              value: "ขึ้นลง",
                              label: "ขึ้นลง",
                            },
                            {
                              value: "ขึ้นลง - ซ้ายขวา",
                              label: "ขึ้นลง - ซ้ายขวา",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>ฟอกอากาศ :</p>
                        <Select
                          name="purify"
                          onChange={(value) => this.setState({ purify: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกฟอกอากาศ"
                          options={[
                            {
                              value: "แผ่นฟอก",
                              label: "แผ่นฟอก",
                            },
                            {
                              value: "ฟอกไฟฟ้า",
                              label: "ฟอกไฟฟ้า",
                            },
                            {
                              value: "ไม่มีระบบฟอก",
                              label: "ไม่มีระบบฟอก",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>น้ำยา :</p>
                        <Input
                          type="text"
                          name="liquid"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>แคตตาล็อก :</p>
                        <Input
                          type="text"
                          name="catalog"
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>รายละเอียดเพิ่มเติม :</p>
                        <Input.TextArea
                          name="description"
                          value={this.state.description}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                    </div>
                  </form>
                  {/* <form className="catalog">
                      <div className="catalog-title">
                          <p>แคตตาล็อก (PDF)</p>
                      </div>
                      <div className="filename">
                          <p>{this.state.catalog.name}</p>
                      </div>
                      <div className="file-input">
                          <input id="catalog" type="file" name="catalog" accept="image/jpeg,image/gif,image/png,application/pdf" hidden onChange={(event) => this._onHandleChange(event)}/>
                          <label htmlFor="catalog">เลือกไฟล์</label>
                      </div>
                  </form> */}
                  <div
                    className="action-button"
                    style={{
                      marginBottom: "20px",
                      paddingLeft: "187px",
                      paddingTop: 0,
                    }}
                  >
                    {this.props.loading ? (
                      <div>
                        <p style={{ textAlign: "left" }}>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        <Button type="primary" onClick={() => this._onSubmit()}>
                          บันทึก
                        </Button>
                        <Button onClick={() => window.history.back()}>
                          กลับ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, product }) => {
  return {
    user: auth.user,
    loading: product.loading,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  productCreate,
})(AdminAddProduct);
